import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  StockListReq,
  StockListRes,
  CreateStockReq,
  ActionStockRes,
  UpdateStockReq,
  DeleteStockReq,
  StockDetailReq,
  StockData,
  GrnHistoryListReq,
  GrnHistoryListRes,
  GrnByProductListReq,
  GrnByProductListRes,
  ManageStockLogsReq,
  ManageStockLogsRes,
  ManageOnlineStockReq,
  GrnProductsListReq,
  GrnProductsListRes,
  StockMoveMentReq,
  StockMoveMentRes,
  StockConfigDetailReq,
  UpdateStockConfigReq,
  StockConfigDetailRes,
  DelteStockConfigReq,
  ActionRes,
  CountReq,
  CountRes,
} from './types'

export const getStockListAction = createAsyncAction(
  'STOCK/GET_STOCK_LIST_REQ',
  'STOCK/GET_STOCK_LIST_SUCCESS',
  'STOCK/GET_STOCK_LIST_FAILURE',
)<StockListReq, StockListRes, Error>()

export const getStockDetailAction = createAsyncAction(
  'STOCK/GET_STOCK_DETAIL_REQ',
  'STOCK/GET_STOCK_DETAIL_SUCCESS',
  'STOCK/GET_STOCK_DETAIL_FAILURE',
)<StockDetailReq, StockData, Error>()

export const createStockAction = createAsyncAction(
  'STOCK/CREATE_STOCK_REQ',
  'STOCK/CREATE_STOCK_SUCCESS',
  'STOCK/CREATE_STOCK_FAILURE',
)<CreateStockReq, ActionStockRes, Error>()

export const updateStockAction = createAsyncAction(
  'STOCK/UPDATE_STOCK_REQ',
  'STOCK/UPDATE_STOCK_SUCCESS',
  'STOCK/UPDATE_STOCK_FAILURE',
)<UpdateStockReq, ActionStockRes, Error>()

export const deleteStockAction = createAsyncAction(
  'STOCK/DELETE_STOCK_REQ',
  'STOCK/DELETE_STOCK_SUCCESS',
  'STOCK/DELETE_STOCK_FAILURE',
)<DeleteStockReq, ActionStockRes, Error>()

export const getAllStockListAction = createAsyncAction(
  'STOCK/GET_ALL_STOCK_LIST_REQ',
  'STOCK/GET_ALL_STOCK_LIST_SUCCESS',
  'STOCK/GET_ALL_STOCK_LIST_FAILURE',
)<StockListReq, StockListRes, Error>()

export const getGrnHistoryAction = createAsyncAction(
  'STOCK/GET_GRN_HISTORY_LIST_REQ',
  'STOCK/GET_GRN_HISTORY_SUCCESS',
  'STOCK/GET_GRN_HISTORY_FAILURE',
)<GrnHistoryListReq, GrnHistoryListRes, Error>()

export const getGrnListAction = createAsyncAction(
  'STOCK/GET_GRN_LIST_REQ',
  'STOCK/GET_GRN_SUCCESS',
  'STOCK/GET_GRN_FAILURE',
)<GrnByProductListReq, GrnByProductListRes, Error>()

export const getManageStockLogsAction = createAsyncAction(
  'STOCK/GET_STOCK_LOGS_REQ',
  'STOCK/GET_STOCK_LOGS_SUCCESS',
  'STOCK/GET_STOCK_LOGS_FAILURE',
)<ManageStockLogsReq, ManageStockLogsRes, Error>()

export const manageOnlineStockAction = createAsyncAction(
  'STOCK/MANAGE_ONLINE_STOCK_REQ',
  'STOCK/MANAGE_ONLINE_STOCK_SUCCESS',
  'STOCK/MANAGE_ONLINE_STOCK_FAILURE',
)<ManageOnlineStockReq, ActionStockRes, Error>()

export const getProductsGrnListAction = createAsyncAction(
  'STOCK/GET_PRODUCTS_GRN_LIST_REQ',
  'STOCK/GET_PRODUCTS_GRN_LIST_SUCCESS',
  'STOCK/GET_PRODUCTS_GRN_LIST_FAILURE',
)<GrnProductsListReq, GrnProductsListRes, Error>()

export const getStockMovementListAction = createAsyncAction(
  'STOCK/GET_STOCK_MOVEMENT_LIST_REQ',
  'STOCK/GET_STOCK_MOVEMENT_LIST_SUCCESS',
  'STOCK/GET_STOCK_MOVEMENT_LIST_FAILURE',
)<StockMoveMentReq, StockMoveMentRes, Error>()

export const getStockConfigDetailAction = createAsyncAction(
  'STOCK/GET_CONFIG_DETAIL_REQ',
  'STOCK/GET_CONFIG_SUCCESS',
  'STOCK/GET_CONFIG_FAILURE',
)<StockConfigDetailReq, StockConfigDetailRes, Error>()

export const updateConfigStockAction = createAsyncAction(
  'STOCK/UPDATE_CONFIG_STOCK_REQ',
  'STOCK/UPDATE_CONFIG_STOCK_SUCCESS',
  'STOCK/UPDATE_CONFIG_STOCK_FAILURE',
)<UpdateStockConfigReq, ActionRes, Error>()

export const deleteConfigStockAction = createAsyncAction(
  'STOCK/DELETE_CONFIG_STOCK_REQ',
  'STOCK/DELETE_CONFIG_STOCK_SUCCESS',
  'STOCK/DELETE_CONFIG_STOCK_FAILURE',
)<DelteStockConfigReq, ActionRes, Error>()

export const getCountAction = createAsyncAction(
  'STOCK/GET_COUNT_REQ',
  'STOCK/GET_COUNT_SUCCESS',
  'STOCK/GET_COUNT_FAILURE',
)<CountReq, CountRes, Error>()

export const clearEventAction = createStandardAction('STOCK/CLEAR_EVENT')<void>()
